import { gsap } from 'gsap/dist/gsap';

/**************************************************************
-> Dropdown logic and interactivity
**************************************************************/
export function dropdown() {
  const dropdowns = document.querySelectorAll('.dropdown-component')

  if (dropdowns) {

    dropdowns.forEach(dropdown => {
      const arrow = dropdown.querySelector('.arrow')
      const list = dropdown.querySelector('.list')
      const currentItem = dropdown.querySelector('.current')
      let openState = false
      
      dropdown.addEventListener('click', () => {
        
        if (openState === false) {
          openState = true

          if (window.innerWidth < 640) {
            // Mobile animation
            gsap.to(dropdown, { height: 'auto', duration: 0.3 })
            gsap.to(list, { pointerEvents: 'all', height: 'auto', duration: 0.3 })
            gsap.to(arrow, { rotation: 180, duration: 0.3 })
          } else {
            // Desktop animation
            gsap.to(list, { opacity: 1, pointerEvents: 'all', duration: 0.3 })
            gsap.to(arrow, { rotation: 180, duration: 0.3 })
          }

          currentItem.classList.add('text-white')

        } else {
          openState = false

          if (window.innerWidth < 640) {
            // Mobile animation
            gsap.to(dropdown, { height: '8rem', duration: 0.3 })
            gsap.to(list, { pointerEvents: 'none', height: 0, duration: 0.3 })
            gsap.to(arrow, { rotation: 0, duration: 0.3 })
          } else {
            // Desktop animation
            gsap.to(list, { opacity: 0, pointerEvents: 'none', duration: 0.3 })
            gsap.to(arrow, { rotation: 0, duration: 0.3 })
          }

          currentItem.classList.remove('text-white')

        }

      })
    })

  }
}


// WEBPACK FOOTER //
// ./scripts/components/dropdown.js